<template>
	<CCallout type="info" icon="folder" class="folder-upsell-callout py-3 mx-4">
		You lost your folders!
		<RouterLink :to="upgradeLink">Upgrade now</RouterLink> to restore them.
	</CCallout>
</template>

<script lang="ts">
	import CCallout from 'src/components/content/Callout.vue';

	export default {
		name: 'CFolderUpsell',
		components: {
			CCallout
		},
		props: {
			orgCode: { type: String, required: true }
		},
		computed: {
			upgradeLink() {
				return '/' + this.orgCode + '/settings/plan/select?source=upgrade-folders';
			}
		}
	};
</script>

<style lang="scss">
.folder-upsell-callout {
	border-color: var(--accent-5);
	box-shadow: 0 -1px 4px rgba($midnight, .2);
}
</style>